/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React, { useState } from 'react';
import { makeStyles, Button, TextField, Box, Typography } from '@material-ui/core';

import MergeTypeIcon from '@material-ui/icons/MergeType';
import { useTranslation } from 'react-i18next';
import Backdrop from '../../../../components/backdrop/Backdrop';
import useMergeUserAccount from '../../../../redux/features/users/merge/useMergeUserAccount';
import MergeUserAccountDialog from '../../../../components/user/mergeUserAccountDialog';

const useStyles = makeStyles(theme => ({
  mergeAccountContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '1rem',
  },
  textField: {
    maxWidth: '25rem',
    margin: '1rem 0 1.5rem 0',
  },
  subtitle: {
    fontSize: '1.2rem',
    fontWeight: '400',
    maxWidth: '35rem',
    marginTop: theme.spacing(2),
  },
}));

export default function MergeAccount() {
  const classes = useStyles();
  const { t } = useTranslation();

  const {
    isLoading,
    mergeDialog,
    mergeButtonActive,
    mergeAvailable,
    userToMergeId,
    error,
    mergeSucceeded,
    onToggleMergeDialog,
    onMergeUserConfirm,
    onKeyUp,
  } = useMergeUserAccount();

  const [value, setValue] = useState('');
  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const cleanTextField = () => {
    setValue('');
  };

  return (
    <Box className={classes.mergeAccount}>
      <Typography variant="h6" component="h6" gutterBottom>
        {t('user.management.merge-account')}
      </Typography>
      <Typography className={classes.subtitle} variant="h6" color="textSecondary" gutterBottom>
        {t('user.management.merge-account.description')}
      </Typography>

      <div className={classes.mergeAccountContainer}>
        {isLoading && <Backdrop blocking={true} />}
        <TextField
          aria-label={t('user-management.merge.emailusername')}
          className={classes.textField}
          label={t('user-management.merge.emailusername')}
          size="small"
          variant="outlined"
          inputProps={{ 'data-testid': 'mergeAccountTextField' }}
          onKeyUp={event => onKeyUp(event.target.value)}
          onChange={handleChange}
          value={value}
        />
        <div>
          <Button
            aria-label={t('user.management.merge-account.button')}
            variant="contained"
            color="default"
            disabled={!mergeButtonActive}
            className={classes.button}
            startIcon={<MergeTypeIcon />}
            onClick={() => onToggleMergeDialog(true)}
          >
            {t('user.management.merge-account.button')}
          </Button>
        </div>
        {mergeDialog.open && (
          <MergeUserAccountDialog
            mergeAvailable={mergeAvailable}
            userToMergeId={userToMergeId}
            error={error}
            dialog={mergeDialog}
            mergeSucceeded={mergeSucceeded}
            toggleDialog={onToggleMergeDialog}
            onSubmit={onMergeUserConfirm}
            cleanTextField={cleanTextField}
          />
        )}
      </div>
    </Box>
  );
}
